import { ACTION_TYPES } from "../components/contact-sales-hubspot-form-component-consts";
/**
 * Trigger file download by creating a temporary link element
 */ const triggerFileDownload = (downloadUrl)=>{
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = '';
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};
/**
 * Send message to parent frame (for iframe communication)
 */ const notifyParentFrame = (message)=>{
    window.parent.postMessage(message, "*");
};
/**
 * Determine what action to take after form submission based on configuration
 */ const determinePostSubmissionAction = (urlToRedirectAfterSubmission, formConfig)=>{
    if (urlToRedirectAfterSubmission) {
        return {
            finalRedirectUrl: urlToRedirectAfterSubmission,
            actionType: ACTION_TYPES.REDIRECT
        };
    }
    if (formConfig === null || formConfig === void 0 ? void 0 : formConfig.downloadUrl) {
        return {
            downloadUrl: formConfig.downloadUrl,
            actionType: ACTION_TYPES.DOWNLOAD
        };
    }
    if (formConfig === null || formConfig === void 0 ? void 0 : formConfig.redirectUrl) {
        return {
            finalRedirectUrl: formConfig.redirectUrl,
            actionType: ACTION_TYPES.REDIRECT
        };
    }
    if ((formConfig === null || formConfig === void 0 ? void 0 : formConfig.inlineMessage) || (formConfig === null || formConfig === void 0 ? void 0 : formConfig.thankYouMessage)) {
        return {
            actionType: ACTION_TYPES.MESSAGE
        };
    }
    return {
        actionType: ACTION_TYPES.REDIRECT
    };
};
/**
 * Handle post-submission actions (downloads, redirects, messages)
 */ const executePostSubmissionAction = (actionData, formConfig)=>{
    const { finalRedirectUrl, downloadUrl, actionType } = actionData;
    // Handle file downloads
    if (downloadUrl) {
        triggerFileDownload(downloadUrl);
        notifyParentFrame({
            type: "formSubmit",
            action: "download",
            downloadUrl
        });
    }
    // Handle redirects
    const redirectUrl = downloadUrl || finalRedirectUrl;
    if (redirectUrl) {
        notifyParentFrame({
            type: "formSubmit",
            redirectUrl
        });
    }
    return {
        success: true,
        redirectUrl,
        downloadUrl,
        actionType,
        inlineMessage: (formConfig === null || formConfig === void 0 ? void 0 : formConfig.inlineMessage) || (formConfig === null || formConfig === void 0 ? void 0 : formConfig.thankYouMessage)
    };
};
/**
 * Complete post-submission handling process
 * Consolidates action determination and execution into a single function
 */ export const handleCompletePostSubmission = (urlToRedirectAfterSubmission, formConfig)=>{
    // Determine what action to take
    const actionData = determinePostSubmissionAction(urlToRedirectAfterSubmission, formConfig);
    // Execute the determined action
    return executePostSubmissionAction(actionData, formConfig);
};
